// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSearchPath = 'M4.002 7.86c0-2.707 2.242-4.9 5.007-4.9 2.764 0 5.006 2.193 5.006 4.9 0 2.705-2.242 4.898-5.006 4.898-2.765 0-5.007-2.193-5.007-4.899ZM9.01 1C5.138 1 2 4.07 2 7.86c0 3.787 3.138 6.858 7.009 6.858a7.097 7.097 0 0 0 3.377-.847L16.412 19 18 17.806l-4.016-5.116a6.764 6.764 0 0 0 2.033-4.83c0-3.79-3.138-6.86-7.008-6.86Z';
var IconSearch = baseIcon('IconSearch', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSearchPath
});
export default IconSearch;
//# sourceMappingURL=index.js.map